import axios from 'axios'
import React from 'react'
import base_url from '../utils/getlink'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useState } from 'react'
import { Heading } from '@chakra-ui/layout';
import ProductCard from './ProductCard'

const getProducts = (service)=>{
    return axios({
        method:'get',
        url:`${base_url}/products/service?service=${service}`
    })
}

const Products = () => {
    const [searchPrams,setSearchPrams]= useSearchParams();
    const [productData,setProductData]= useState([]);
    const navigate = useNavigate();
    useEffect(()=>{
        if(searchPrams.get("service")===null || !searchPrams.get("service")){
            navigate('/')
        }

        getProducts(searchPrams.get('service'))
        .then((res)=>{
            console.log(res.data.data);
            setProductData(res.data.data);
        })
        .catch((err)=>{
            console.log('something went wrong.');
        })
    },[searchPrams,setSearchPrams,setProductData,navigate])
  return (
    <div>
        <br/>
        <div>
        <Heading textTransform={'capitalize'}>{searchPrams.get('service')}</Heading>
        </div>
        <br/>
        <div>
            {productData.length>0&&productData.map((product)=>{
                return (
                    <ProductCard key={product._id} props={product} />
                )
            })}
        </div>
    </div>
  )
}

export default Products